export default __webpack_public_path__ + "static/media/tour-assign.6b32e9ec.svg";